import './component';
import './config';
import './preview';

Shopware.Service('cmsService').registerCmsElement({
    name: 'acris-blog-author-date',
    label: 'acris-blog.elements.blogAuthorDate.label',
    component: 'sw-cms-el-acris-blog-author-date',
    configComponent: 'sw-cms-el-config-acris-blog-author-date',
    previewComponent: 'sw-cms-el-preview-acris-blog-author-date',
    defaultConfig: {
        layout: {
            source: 'static',
            value: 'default',
        }
    }
});